<header class="page-subheader">
  <div class="nav-row">
    <button
      *ngIf="showBack"
      type="button"
      class="back-btn"
      (click)="onBack()">
      <img src="assets/images/back_icon.svg" alt="" height="20" width="20" />
      <span>{{ backLabel }}</span>
    </button>
  </div>

  <div class="title-row-stacked" *ngIf="title || titleLoading">
    <h1 class="title" *ngIf="title">{{ title }}</h1>
    <ngx-skeleton-loader
      *ngIf="titleLoading && !title"
      class="title-skeleton"
      count="1"
      appearance="line"
      [theme]="titleSkeletonTheme"></ngx-skeleton-loader>
    <ng-content select="[subheaderTitleRight]"></ng-content>
    <span class="meta" *ngIf="meta">{{ meta }}</span>
  </div>

  <div class="toolbar-row" *ngIf="showSearch">
    <div class="toolbar-left">
      <app-search-bar
        class="search"
        [disabled]="searchDisabled"
        [placeholder]="searchPlaceholder"
        [ariaLabel]="searchAriaLabel || searchPlaceholder"
        [prefixImageSrc]="searchPrefixImageSrc"
        [clearImageSrc]="searchClearImageSrc"
        [ngModel]="searchValue"
        (ngModelChange)="onSearchChange($event)"
        (valueInput)="searchInput.emit($event)"
        (cleared)="searchCleared.emit()"
      ></app-search-bar>
    </div>

    <div class="toolbar-right">
      <ng-content select="[subheaderToolbar]"></ng-content>
    </div>
  </div>
</header>
